import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import JobOrderPreview from '../../components/pageModule/Joborderlpos/JobOrderLpoPreview';
import { fetchJobOrderLpo, setSelected, clearCurrentJobOrderLpo } from '../../store/modules/joborderlpo/joborderlpoActions';

const JoborderlposView = () => {
    const joborderState = useSelector(state => state.joborderlpo);
    const dispatch = useDispatch();
    const { id } = useParams();
    const isInitialized = useRef(false);
    const [isLoading, setIsLoading] = useState(false);

    // Debug logging
    console.log('JoborderlposView - joborderState:', joborderState);
    console.log('JoborderlposView - current:', joborderState.current);
    console.log('JoborderlposView - id:', id);
    console.log('JoborderlposView - isLoading:', isLoading);

    const actions = {
        fetchSingle: (id) => dispatch(fetchJobOrderLpo(id)),
        setItemsSelected: (selectedRows) => dispatch(setSelected(selectedRows)),
        clearCurrent: () => dispatch(clearCurrentJobOrderLpo())
    };

    // Fetch function with proper dependencies using actions
    const fetchData = useCallback(async (id) => {
        try {
            setIsLoading(true);
            const data = await actions.fetchSingle(id);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false);
        }
    }, [actions]);

    // Initial data fetch
    useEffect(() => {
        if (!isInitialized.current) {
            isInitialized.current = true;
            fetchData(id);
        }
    }, [fetchData, id]);

    // Cleanup when component unmounts
    // useEffect(() => {
    //     return () => {
    //         actions.clearCurrent();
    //     };
    // }, [actions]);

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <JobOrderPreview 
                                    data={joborderState.current}
                                    isLoading={isLoading}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default JoborderlposView;
